import application from 'application/application';

import template from './blocked-user.template.html';

import controller from './blocked-user.controller';



application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.default.blockedUser', {
				url: '/usuario-bloqueado',
				views: {
					'default@root.default': {
						templateUrl: template,
						controller
					}
				},
				data: {
					documentTitle: 'Usuário bloqueado'
				}
			});

	}]);
